// AUTO-GENERATED reference data. Do not edit by hand.
// Countries: ISO 3166-1 (numeric code as value). MCC: ISO 18245.
import { DropdownOption } from "components/searchable-dropdown/types";

export interface Country {
  /** ISO 3166-1 numeric code, e.g. 840 for the United States. */
  code: number;
  alpha2: string;
  alpha3: string;
  name: string;
}

export const COUNTRIES: Country[] = [
  // { code: 4, alpha2: "AF", alpha3: "AFG", name: "Afghanistan" },
  // { code: 248, alpha2: "AX", alpha3: "ALA", name: "Åland Islands" },
  // { code: 8, alpha2: "AL", alpha3: "ALB", name: "Albania" },
  // { code: 12, alpha2: "DZ", alpha3: "DZA", name: "Algeria" },
  // { code: 16, alpha2: "AS", alpha3: "ASM", name: "American Samoa" },
  // { code: 20, alpha2: "AD", alpha3: "AND", name: "Andorra" },
  // { code: 24, alpha2: "AO", alpha3: "AGO", name: "Angola" },
  // { code: 660, alpha2: "AI", alpha3: "AIA", name: "Anguilla" },
  // { code: 10, alpha2: "AQ", alpha3: "ATA", name: "Antarctica" },
  // { code: 28, alpha2: "AG", alpha3: "ATG", name: "Antigua and Barbuda" },
  // { code: 32, alpha2: "AR", alpha3: "ARG", name: "Argentina" },
  // { code: 51, alpha2: "AM", alpha3: "ARM", name: "Armenia" },
  // { code: 533, alpha2: "AW", alpha3: "ABW", name: "Aruba" },
  // { code: 36, alpha2: "AU", alpha3: "AUS", name: "Australia" },
  // { code: 40, alpha2: "AT", alpha3: "AUT", name: "Austria" },
  // { code: 31, alpha2: "AZ", alpha3: "AZE", name: "Azerbaijan" },
  // { code: 44, alpha2: "BS", alpha3: "BHS", name: "Bahamas" },
  // { code: 48, alpha2: "BH", alpha3: "BHR", name: "Bahrain" },
  // { code: 50, alpha2: "BD", alpha3: "BGD", name: "Bangladesh" },
  // { code: 52, alpha2: "BB", alpha3: "BRB", name: "Barbados" },
  // { code: 112, alpha2: "BY", alpha3: "BLR", name: "Belarus" },
  // { code: 56, alpha2: "BE", alpha3: "BEL", name: "Belgium" },
  // { code: 84, alpha2: "BZ", alpha3: "BLZ", name: "Belize" },
  // { code: 204, alpha2: "BJ", alpha3: "BEN", name: "Benin" },
  // { code: 60, alpha2: "BM", alpha3: "BMU", name: "Bermuda" },
  // { code: 64, alpha2: "BT", alpha3: "BTN", name: "Bhutan" },
  // { code: 68, alpha2: "BO", alpha3: "BOL", name: "Bolivia, Plurinational State of" },
  // { code: 535, alpha2: "BQ", alpha3: "BES", name: "Bonaire, Sint Eustatius and Saba" },
  // { code: 70, alpha2: "BA", alpha3: "BIH", name: "Bosnia and Herzegovina" },
  // { code: 72, alpha2: "BW", alpha3: "BWA", name: "Botswana" },
  // { code: 74, alpha2: "BV", alpha3: "BVT", name: "Bouvet Island" },
  // { code: 76, alpha2: "BR", alpha3: "BRA", name: "Brazil" },
  // { code: 86, alpha2: "IO", alpha3: "IOT", name: "British Indian Ocean Territory" },
  // { code: 96, alpha2: "BN", alpha3: "BRN", name: "Brunei Darussalam" },
  // { code: 100, alpha2: "BG", alpha3: "BGR", name: "Bulgaria" },
  // { code: 854, alpha2: "BF", alpha3: "BFA", name: "Burkina Faso" },
  // { code: 108, alpha2: "BI", alpha3: "BDI", name: "Burundi" },
  // { code: 132, alpha2: "CV", alpha3: "CPV", name: "Cabo Verde" },
  // { code: 116, alpha2: "KH", alpha3: "KHM", name: "Cambodia" },
  // { code: 120, alpha2: "CM", alpha3: "CMR", name: "Cameroon" },
  // { code: 124, alpha2: "CA", alpha3: "CAN", name: "Canada" },
  // { code: 136, alpha2: "KY", alpha3: "CYM", name: "Cayman Islands" },
  // { code: 140, alpha2: "CF", alpha3: "CAF", name: "Central African Republic" },
  // { code: 148, alpha2: "TD", alpha3: "TCD", name: "Chad" },
  // { code: 152, alpha2: "CL", alpha3: "CHL", name: "Chile" },
  // { code: 156, alpha2: "CN", alpha3: "CHN", name: "China" },
  // { code: 162, alpha2: "CX", alpha3: "CXR", name: "Christmas Island" },
  // { code: 166, alpha2: "CC", alpha3: "CCK", name: "Cocos (Keeling) Islands" },
  // { code: 170, alpha2: "CO", alpha3: "COL", name: "Colombia" },
  // { code: 174, alpha2: "KM", alpha3: "COM", name: "Comoros" },
  // { code: 178, alpha2: "CG", alpha3: "COG", name: "Congo" },
  // { code: 180, alpha2: "CD", alpha3: "COD", name: "Congo, Democratic Republic of the" },
  // { code: 184, alpha2: "CK", alpha3: "COK", name: "Cook Islands" },
  // { code: 188, alpha2: "CR", alpha3: "CRI", name: "Costa Rica" },
  // { code: 384, alpha2: "CI", alpha3: "CIV", name: "Côte d'Ivoire" },
  // { code: 191, alpha2: "HR", alpha3: "HRV", name: "Croatia" },
  // { code: 192, alpha2: "CU", alpha3: "CUB", name: "Cuba" },
  // { code: 531, alpha2: "CW", alpha3: "CUW", name: "Curaçao" },
  // { code: 196, alpha2: "CY", alpha3: "CYP", name: "Cyprus" },
  // { code: 203, alpha2: "CZ", alpha3: "CZE", name: "Czechia" },
  // { code: 208, alpha2: "DK", alpha3: "DNK", name: "Denmark" },
  // { code: 262, alpha2: "DJ", alpha3: "DJI", name: "Djibouti" },
  // { code: 212, alpha2: "DM", alpha3: "DMA", name: "Dominica" },
  // { code: 214, alpha2: "DO", alpha3: "DOM", name: "Dominican Republic" },
  // { code: 218, alpha2: "EC", alpha3: "ECU", name: "Ecuador" },
  // { code: 818, alpha2: "EG", alpha3: "EGY", name: "Egypt" },
  // { code: 222, alpha2: "SV", alpha3: "SLV", name: "El Salvador" },
  // { code: 226, alpha2: "GQ", alpha3: "GNQ", name: "Equatorial Guinea" },
  // { code: 232, alpha2: "ER", alpha3: "ERI", name: "Eritrea" },
  // { code: 233, alpha2: "EE", alpha3: "EST", name: "Estonia" },
  // { code: 748, alpha2: "SZ", alpha3: "SWZ", name: "Eswatini" },
  // { code: 231, alpha2: "ET", alpha3: "ETH", name: "Ethiopia" },
  // { code: 238, alpha2: "FK", alpha3: "FLK", name: "Falkland Islands (Malvinas)" },
  // { code: 234, alpha2: "FO", alpha3: "FRO", name: "Faroe Islands" },
  // { code: 242, alpha2: "FJ", alpha3: "FJI", name: "Fiji" },
  // { code: 246, alpha2: "FI", alpha3: "FIN", name: "Finland" },
  // { code: 250, alpha2: "FR", alpha3: "FRA", name: "France" },
  // { code: 254, alpha2: "GF", alpha3: "GUF", name: "French Guiana" },
  // { code: 258, alpha2: "PF", alpha3: "PYF", name: "French Polynesia" },
  // { code: 260, alpha2: "TF", alpha3: "ATF", name: "French Southern Territories" },
  // { code: 266, alpha2: "GA", alpha3: "GAB", name: "Gabon" },
  // { code: 270, alpha2: "GM", alpha3: "GMB", name: "Gambia" },
  // { code: 268, alpha2: "GE", alpha3: "GEO", name: "Georgia" },
  // { code: 276, alpha2: "DE", alpha3: "DEU", name: "Germany" },
  // { code: 288, alpha2: "GH", alpha3: "GHA", name: "Ghana" },
  // { code: 292, alpha2: "GI", alpha3: "GIB", name: "Gibraltar" },
  { code: 300, alpha2: "GR", alpha3: "GRC", name: "Greece" },
  // { code: 304, alpha2: "GL", alpha3: "GRL", name: "Greenland" },
  // { code: 308, alpha2: "GD", alpha3: "GRD", name: "Grenada" },
  // { code: 312, alpha2: "GP", alpha3: "GLP", name: "Guadeloupe" },
  // { code: 316, alpha2: "GU", alpha3: "GUM", name: "Guam" },
  // { code: 320, alpha2: "GT", alpha3: "GTM", name: "Guatemala" },
  // { code: 831, alpha2: "GG", alpha3: "GGY", name: "Guernsey" },
  // { code: 324, alpha2: "GN", alpha3: "GIN", name: "Guinea" },
  // { code: 624, alpha2: "GW", alpha3: "GNB", name: "Guinea-Bissau" },
  // { code: 328, alpha2: "GY", alpha3: "GUY", name: "Guyana" },
  // { code: 332, alpha2: "HT", alpha3: "HTI", name: "Haiti" },
  // { code: 334, alpha2: "HM", alpha3: "HMD", name: "Heard Island and McDonald Islands" },
  // { code: 336, alpha2: "VA", alpha3: "VAT", name: "Holy See" },
  // { code: 340, alpha2: "HN", alpha3: "HND", name: "Honduras" },
  // { code: 344, alpha2: "HK", alpha3: "HKG", name: "Hong Kong" },
  // { code: 348, alpha2: "HU", alpha3: "HUN", name: "Hungary" },
  // { code: 352, alpha2: "IS", alpha3: "ISL", name: "Iceland" },
  // { code: 356, alpha2: "IN", alpha3: "IND", name: "India" },
  // { code: 360, alpha2: "ID", alpha3: "IDN", name: "Indonesia" },
  // { code: 364, alpha2: "IR", alpha3: "IRN", name: "Iran, Islamic Republic of" },
  // { code: 368, alpha2: "IQ", alpha3: "IRQ", name: "Iraq" },
  // { code: 372, alpha2: "IE", alpha3: "IRL", name: "Ireland" },
  // { code: 833, alpha2: "IM", alpha3: "IMN", name: "Isle of Man" },
  // { code: 376, alpha2: "IL", alpha3: "ISR", name: "Israel" },
  // { code: 380, alpha2: "IT", alpha3: "ITA", name: "Italy" },
  // { code: 388, alpha2: "JM", alpha3: "JAM", name: "Jamaica" },
  // { code: 392, alpha2: "JP", alpha3: "JPN", name: "Japan" },
  // { code: 832, alpha2: "JE", alpha3: "JEY", name: "Jersey" },
  // { code: 400, alpha2: "JO", alpha3: "JOR", name: "Jordan" },
  // { code: 398, alpha2: "KZ", alpha3: "KAZ", name: "Kazakhstan" },
  // { code: 404, alpha2: "KE", alpha3: "KEN", name: "Kenya" },
  // { code: 296, alpha2: "KI", alpha3: "KIR", name: "Kiribati" },
  // { code: 408, alpha2: "KP", alpha3: "PRK", name: "Korea, Democratic People's Republic of" },
  // { code: 410, alpha2: "KR", alpha3: "KOR", name: "Korea, Republic of" },
  // { code: 414, alpha2: "KW", alpha3: "KWT", name: "Kuwait" },
  // { code: 417, alpha2: "KG", alpha3: "KGZ", name: "Kyrgyzstan" },
  // { code: 418, alpha2: "LA", alpha3: "LAO", name: "Lao People's Democratic Republic" },
  // { code: 428, alpha2: "LV", alpha3: "LVA", name: "Latvia" },
  // { code: 422, alpha2: "LB", alpha3: "LBN", name: "Lebanon" },
  // { code: 426, alpha2: "LS", alpha3: "LSO", name: "Lesotho" },
  // { code: 430, alpha2: "LR", alpha3: "LBR", name: "Liberia" },
  // { code: 434, alpha2: "LY", alpha3: "LBY", name: "Libya" },
  // { code: 438, alpha2: "LI", alpha3: "LIE", name: "Liechtenstein" },
  // { code: 440, alpha2: "LT", alpha3: "LTU", name: "Lithuania" },
  // { code: 442, alpha2: "LU", alpha3: "LUX", name: "Luxembourg" },
  // { code: 446, alpha2: "MO", alpha3: "MAC", name: "Macao" },
  // { code: 450, alpha2: "MG", alpha3: "MDG", name: "Madagascar" },
  // { code: 454, alpha2: "MW", alpha3: "MWI", name: "Malawi" },
  // { code: 458, alpha2: "MY", alpha3: "MYS", name: "Malaysia" },
  // { code: 462, alpha2: "MV", alpha3: "MDV", name: "Maldives" },
  // { code: 466, alpha2: "ML", alpha3: "MLI", name: "Mali" },
  // { code: 470, alpha2: "MT", alpha3: "MLT", name: "Malta" },
  // { code: 584, alpha2: "MH", alpha3: "MHL", name: "Marshall Islands" },
  // { code: 474, alpha2: "MQ", alpha3: "MTQ", name: "Martinique" },
  // { code: 478, alpha2: "MR", alpha3: "MRT", name: "Mauritania" },
  // { code: 480, alpha2: "MU", alpha3: "MUS", name: "Mauritius" },
  // { code: 175, alpha2: "YT", alpha3: "MYT", name: "Mayotte" },
  // { code: 484, alpha2: "MX", alpha3: "MEX", name: "Mexico" },
  // { code: 583, alpha2: "FM", alpha3: "FSM", name: "Micronesia, Federated States of" },
  // { code: 498, alpha2: "MD", alpha3: "MDA", name: "Moldova, Republic of" },
  // { code: 492, alpha2: "MC", alpha3: "MCO", name: "Monaco" },
  // { code: 496, alpha2: "MN", alpha3: "MNG", name: "Mongolia" },
  // { code: 499, alpha2: "ME", alpha3: "MNE", name: "Montenegro" },
  // { code: 500, alpha2: "MS", alpha3: "MSR", name: "Montserrat" },
  // { code: 504, alpha2: "MA", alpha3: "MAR", name: "Morocco" },
  // { code: 508, alpha2: "MZ", alpha3: "MOZ", name: "Mozambique" },
  // { code: 104, alpha2: "MM", alpha3: "MMR", name: "Myanmar" },
  // { code: 516, alpha2: "NA", alpha3: "NAM", name: "Namibia" },
  // { code: 520, alpha2: "NR", alpha3: "NRU", name: "Nauru" },
  // { code: 524, alpha2: "NP", alpha3: "NPL", name: "Nepal" },
  // { code: 528, alpha2: "NL", alpha3: "NLD", name: "Netherlands, Kingdom of the" },
  // { code: 540, alpha2: "NC", alpha3: "NCL", name: "New Caledonia" },
  // { code: 554, alpha2: "NZ", alpha3: "NZL", name: "New Zealand" },
  // { code: 558, alpha2: "NI", alpha3: "NIC", name: "Nicaragua" },
  // { code: 562, alpha2: "NE", alpha3: "NER", name: "Niger" },
  // { code: 566, alpha2: "NG", alpha3: "NGA", name: "Nigeria" },
  // { code: 570, alpha2: "NU", alpha3: "NIU", name: "Niue" },
  // { code: 574, alpha2: "NF", alpha3: "NFK", name: "Norfolk Island" },
  // { code: 807, alpha2: "MK", alpha3: "MKD", name: "North Macedonia" },
  // { code: 580, alpha2: "MP", alpha3: "MNP", name: "Northern Mariana Islands" },
  // { code: 578, alpha2: "NO", alpha3: "NOR", name: "Norway" },
  // { code: 512, alpha2: "OM", alpha3: "OMN", name: "Oman" },
  // { code: 586, alpha2: "PK", alpha3: "PAK", name: "Pakistan" },
  // { code: 585, alpha2: "PW", alpha3: "PLW", name: "Palau" },
  // { code: 275, alpha2: "PS", alpha3: "PSE", name: "Palestine, State of" },
  // { code: 591, alpha2: "PA", alpha3: "PAN", name: "Panama" },
  // { code: 598, alpha2: "PG", alpha3: "PNG", name: "Papua New Guinea" },
  // { code: 600, alpha2: "PY", alpha3: "PRY", name: "Paraguay" },
  // { code: 604, alpha2: "PE", alpha3: "PER", name: "Peru" },
  // { code: 608, alpha2: "PH", alpha3: "PHL", name: "Philippines" },
  // { code: 612, alpha2: "PN", alpha3: "PCN", name: "Pitcairn" },
  // { code: 616, alpha2: "PL", alpha3: "POL", name: "Poland" },
  // { code: 620, alpha2: "PT", alpha3: "PRT", name: "Portugal" },
  // { code: 630, alpha2: "PR", alpha3: "PRI", name: "Puerto Rico" },
  // { code: 634, alpha2: "QA", alpha3: "QAT", name: "Qatar" },
  // { code: 638, alpha2: "RE", alpha3: "REU", name: "Réunion" },
  // { code: 642, alpha2: "RO", alpha3: "ROU", name: "Romania" },
  // { code: 643, alpha2: "RU", alpha3: "RUS", name: "Russian Federation" },
  // { code: 646, alpha2: "RW", alpha3: "RWA", name: "Rwanda" },
  // { code: 652, alpha2: "BL", alpha3: "BLM", name: "Saint Barthélemy" },
  // { code: 654, alpha2: "SH", alpha3: "SHN", name: "Saint Helena, Ascension and Tristan da Cunha" },
  // { code: 659, alpha2: "KN", alpha3: "KNA", name: "Saint Kitts and Nevis" },
  // { code: 662, alpha2: "LC", alpha3: "LCA", name: "Saint Lucia" },
  // { code: 663, alpha2: "MF", alpha3: "MAF", name: "Saint Martin (French part)" },
  // { code: 666, alpha2: "PM", alpha3: "SPM", name: "Saint Pierre and Miquelon" },
  // { code: 670, alpha2: "VC", alpha3: "VCT", name: "Saint Vincent and the Grenadines" },
  // { code: 882, alpha2: "WS", alpha3: "WSM", name: "Samoa" },
  // { code: 674, alpha2: "SM", alpha3: "SMR", name: "San Marino" },
  // { code: 678, alpha2: "ST", alpha3: "STP", name: "Sao Tome and Principe" },
  // { code: 682, alpha2: "SA", alpha3: "SAU", name: "Saudi Arabia" },
  // { code: 686, alpha2: "SN", alpha3: "SEN", name: "Senegal" },
  // { code: 688, alpha2: "RS", alpha3: "SRB", name: "Serbia" },
  // { code: 690, alpha2: "SC", alpha3: "SYC", name: "Seychelles" },
  // { code: 694, alpha2: "SL", alpha3: "SLE", name: "Sierra Leone" },
  // { code: 702, alpha2: "SG", alpha3: "SGP", name: "Singapore" },
  // { code: 534, alpha2: "SX", alpha3: "SXM", name: "Sint Maarten (Dutch part)" },
  // { code: 703, alpha2: "SK", alpha3: "SVK", name: "Slovakia" },
  // { code: 705, alpha2: "SI", alpha3: "SVN", name: "Slovenia" },
  // { code: 90, alpha2: "SB", alpha3: "SLB", name: "Solomon Islands" },
  // { code: 706, alpha2: "SO", alpha3: "SOM", name: "Somalia" },
  // { code: 710, alpha2: "ZA", alpha3: "ZAF", name: "South Africa" },
  // { code: 239, alpha2: "GS", alpha3: "SGS", name: "South Georgia and the South Sandwich Islands" },
  // { code: 728, alpha2: "SS", alpha3: "SSD", name: "South Sudan" },
  // { code: 724, alpha2: "ES", alpha3: "ESP", name: "Spain" },
  // { code: 144, alpha2: "LK", alpha3: "LKA", name: "Sri Lanka" },
  // { code: 729, alpha2: "SD", alpha3: "SDN", name: "Sudan" },
  // { code: 740, alpha2: "SR", alpha3: "SUR", name: "Suriname" },
  // { code: 744, alpha2: "SJ", alpha3: "SJM", name: "Svalbard and Jan Mayen" },
  // { code: 752, alpha2: "SE", alpha3: "SWE", name: "Sweden" },
  // { code: 756, alpha2: "CH", alpha3: "CHE", name: "Switzerland" },
  // { code: 760, alpha2: "SY", alpha3: "SYR", name: "Syrian Arab Republic" },
  // { code: 158, alpha2: "TW", alpha3: "TWN", name: "Taiwan, Province of China" },
  // { code: 762, alpha2: "TJ", alpha3: "TJK", name: "Tajikistan" },
  // { code: 834, alpha2: "TZ", alpha3: "TZA", name: "Tanzania, United Republic of" },
  // { code: 764, alpha2: "TH", alpha3: "THA", name: "Thailand" },
  // { code: 626, alpha2: "TL", alpha3: "TLS", name: "Timor-Leste" },
  // { code: 768, alpha2: "TG", alpha3: "TGO", name: "Togo" },
  // { code: 772, alpha2: "TK", alpha3: "TKL", name: "Tokelau" },
  // { code: 776, alpha2: "TO", alpha3: "TON", name: "Tonga" },
  // { code: 780, alpha2: "TT", alpha3: "TTO", name: "Trinidad and Tobago" },
  // { code: 788, alpha2: "TN", alpha3: "TUN", name: "Tunisia" },
  // { code: 792, alpha2: "TR", alpha3: "TUR", name: "Türkiye" },
  // { code: 795, alpha2: "TM", alpha3: "TKM", name: "Turkmenistan" },
  // { code: 796, alpha2: "TC", alpha3: "TCA", name: "Turks and Caicos Islands" },
  // { code: 798, alpha2: "TV", alpha3: "TUV", name: "Tuvalu" },
  // { code: 800, alpha2: "UG", alpha3: "UGA", name: "Uganda" },
  // { code: 804, alpha2: "UA", alpha3: "UKR", name: "Ukraine" },
  // { code: 784, alpha2: "AE", alpha3: "ARE", name: "United Arab Emirates" },
  // { code: 826, alpha2: "GB", alpha3: "GBR", name: "United Kingdom of Great Britain and Northern Ireland" },
  // { code: 581, alpha2: "UM", alpha3: "UMI", name: "United States Minor Outlying Islands" },
  { code: 840, alpha2: "US", alpha3: "USA", name: "United States" },
  // { code: 858, alpha2: "UY", alpha3: "URY", name: "Uruguay" },
  // { code: 860, alpha2: "UZ", alpha3: "UZB", name: "Uzbekistan" },
  // { code: 548, alpha2: "VU", alpha3: "VUT", name: "Vanuatu" },
  // { code: 862, alpha2: "VE", alpha3: "VEN", name: "Venezuela, Bolivarian Republic of" },
  // { code: 704, alpha2: "VN", alpha3: "VNM", name: "Viet Nam" },
  // { code: 92, alpha2: "VG", alpha3: "VGB", name: "Virgin Islands (British)" },
  // { code: 850, alpha2: "VI", alpha3: "VIR", name: "Virgin Islands (U.S.)" },
  // { code: 876, alpha2: "WF", alpha3: "WLF", name: "Wallis and Futuna" },
  // { code: 732, alpha2: "EH", alpha3: "ESH", name: "Western Sahara" },
  // { code: 887, alpha2: "YE", alpha3: "YEM", name: "Yemen" },
  // { code: 894, alpha2: "ZM", alpha3: "ZMB", name: "Zambia" },
  // { code: 716, alpha2: "ZW", alpha3: "ZWE", name: "Zimbabwe" },
];

/** Zero-pad a numeric ISO code to its canonical 3-digit form (4 -> "004"). */
const pad3 = (n: number): string => String(n).padStart(3, "0");

export const countryOptions: DropdownOption<number>[] = COUNTRIES.map((c) => ({
  value: c.code,
  label: c.name,
  code: pad3(c.code),
  keywords: `${c.alpha2} ${c.alpha3}`,
}));
